import { render, staticRenderFns } from "./BuyPannel.vue?vue&type=template&id=58e96d3e"
import script from "./BuyPannel.vue?vue&type=script&lang=js"
export * from "./BuyPannel.vue?vue&type=script&lang=js"
import style0 from "./BuyPannel.vue?vue&type=style&index=0&id=58e96d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports